import React from "react";
import { bool, node } from "prop-types";
import * as style from "./styles.module.scss";

const Backdrop = ({ show, children }) =>
  show && (
    <div
      className={`${style.backdrop} d-flex d-flex justify-content-center align-items-center`}
    >
      {children}
    </div>
  );

Backdrop.propTypes = {
  show: bool.isRequired,
  children: node.isRequired,
};

export default Backdrop;
